import { apiRequest } from './client';
import type {
  AuthenticationResult,
  AuthInitResult,
  AuthProfile,
  LoginInput,
} from '../types/auth';

export function getAuthInit(): Promise<AuthInitResult> {
  return apiRequest<AuthInitResult>('/api/auth/init', { auth: false });
}

export function login(input: LoginInput): Promise<AuthenticationResult> {
  return apiRequest<AuthenticationResult>('/api/auth/login', {
    method: 'POST',
    auth: false,
    body: JSON.stringify(input),
  });
}

export function logout(): Promise<{ ok: boolean }> {
  return apiRequest<{ ok: boolean }>('/api/auth/logout', {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export function getMe(): Promise<AuthProfile> {
  return apiRequest<AuthProfile>('/api/auth/me');
}

export function refresh(): Promise<AuthenticationResult> {
  return apiRequest<AuthenticationResult>('/api/auth/refresh', {
    method: 'POST',
    auth: false,
    body: JSON.stringify({}),
  });
}
